<template>

    <div class="question-content">

      <div v-if="question.thumbnail" class="question-thumbnail" :style="{ backgroundImage: 'url(' + question.thumbnail + ')' }"></div>

      <div class="text_wrapper">
        <div class="text_wrapper__text">{{ question.text }}</div>
        <div class="text_wrapper__gbb"></div>
        <div class="text_wrapper__counter">Question {{ cur_pos + 1 }} of {{ max_pos + 1 }}</div>
      </div>

      <QuestionInput ref="question_input" :question="question" @answer="onAnswerReceived"></QuestionInput>

      <div class="question-input" v-if="question.type !== 'radio' || (question.type === 'radio' && tempInput.answer === 'other')">
        <div v-if="question.comment_field" class="form-group">
          <input id="text_answer_comment" v-model="comment" type="text" class="form-control" :placeholder="question.comment_field_text || 'Please Explain'" @keyup="submitAnswerByEnter">
        </div>
      </div>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  components: {
    QuestionInput: () => import('@src/components/survey/questions/QuestionInput.vue'),
  },
  props: {
    questions: Array,
    cur_pos: Number,
    max_pos: Number,
  },
  data() {
    return {
      current_answer: null,
    }
  },
  computed: {
    ...mapGetters('take_survey', ['tempInput']),
    question: function () {
      return this.questions[this.cur_pos]
    },
    comment: {
      get () {
        return this.tempInput.comment || ''
      },
      set (value) {
        this.$store.commit('take_survey/UPDATE_TEMP_QUESTION_COMMENT', {'questionId': this.question.id, 'val': value})
      }
    }
  },
  methods: {
    ...mapMutations('take_survey', ['SET_COMMAND_DO_SUBMIT']),
    onAnswerReceived(answer) {
      alert('PREPARE')
        setTimeout(() => {
          alert('SEND')
        }, 1000)
    },
    parseSelectImageFromListAnswer(i) {
      this.$set(this.question, 'answer_select_image_from_list', i.id)

      if (!this.question.comment_field) {
        setTimeout(() => {
          this.answer()
        }, 1000)
      }

    },
    submitAnswerByEnter: function (e) {
      if (e.keyCode === 13) {
        this.SET_COMMAND_DO_SUBMIT(true)
      }
    },
  },
}
</script>
<style lang="scss" scoped>

.question-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  min-height: 100px;

  width: 100%;
  text-align: left;


  .text_wrapper{

    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    @media only screen and (max-width: 768px) {
      flex-direction: column;
      align-items: start;
    }


    &__text {
      font-size: 30px;
      line-height: 1.5em;
      color: #444;
      font-family: inherit;
      width: 100%;

      @media only screen and (max-width: 768px) {
        max-width: 100%;
      }

    }

    &__gbb {
      min-width: auto;
      @media only screen and (max-width: 768px) {
        margin-bottom: 10px;
      }


    }

    &__counter {
      min-width: 135px;
      text-align: right;

      @media only screen and (max-width: 768px) {
        text-align: left;
        margin-top:0px;
      }
    }

  }

  .question-input {
    text-align: left;
    width: 100%;
    font-size: 1.5em;


    color: #444;

    .radio, .checkbox {
      line-height: 1.1em;
      margin: 25px 0px 0px 0px;
    }

  }

  .question-thumbnail {
    margin-top: 20px;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

  }


}
</style>
